export default function RecordingLocation() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Badge */}
        <div className="flex justify-center mb-6">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{ background: 'rgba(43,111,212,0.1)', color: '#1A3A8F' }}>
            <i className="ri-map-pin-line"></i>
            <span className="font-semibold text-sm whitespace-nowrap">Local da Gravação</span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12 leading-tight">
          Onde a magia <span className="font-serif italic" style={{ color: '#2B6FD4' }}>acontece</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* Info Card */}
          <div className="rounded-3xl p-8 md:p-10" style={{ background: '#f0f5ff' }}>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(43,111,212,0.15)' }}>
                <i className="ri-building-2-line text-3xl" style={{ color: '#2B6FD4' }}></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Container Studio</h3>
                <p className="text-gray-500 text-sm">Estúdio Profissional</p>
              </div>
            </div>

            <div className="flex items-start gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-2-line text-xl" style={{ color: '#2B6FD4' }}></i>
              </div>
              <div>
                <p className="text-gray-700 font-medium">R. Severiano Nunes, 207</p>
                <p className="text-gray-600">Aleixo, Manaus - AM</p>
                <p className="text-gray-600">CEP: 69060-660</p>
              </div>
            </div>

            <a
              href="https://www.google.com/maps/search/R.+Severiano+Nunes,+207+Aleixo+Manaus+AM"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white font-semibold px-6 py-3 rounded-xl transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              style={{ background: 'linear-gradient(90deg, #1A3A8F, #2B6FD4)' }}
            >
              <i className="ri-map-2-line"></i>
              Ver no Google Maps
            </a>
          </div>

          {/* Map Embed */}
          <div className="rounded-3xl overflow-hidden shadow-xl h-80">
            <iframe
              title="Container Studio - Manaus Digital Podcast"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.0!2d-60.0!3d-3.1!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zUi4gU2V2ZXJpYW5vIE51bmVzLCAyMDcgLSBBbGVpeG8sIE1hbmF1cyAtIEFNLCA2OTA2MC02NjA!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr&q=R.+Severiano+Nunes,+207,+Aleixo,+Manaus,+AM,+69060-660"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
